import { Container, autoinject } from "aurelia-dependency-injection";
import { AppSettings } from "../../app-settings";
import { AuthService } from "../../authentication/auth-service";
import { ContainerHelper } from "./container-helper";

declare var Beacon: any;

@autoinject
export class HelpScout {

    constructor(private authService: AuthService) {
        try {
            this.setupHelpScout();
            Beacon("on", "close", () => this.setBeaconIdentify());
        } catch (ex) {
            $("#knowledgebase-button").hide();
        }
    }

    private setupHelpScout() {
        this.setBeaconIdentify();
        const user = ContainerHelper.AuthService.AppUser;
        user.on("refresh", () => this.setBeaconIdentify());
        Beacon("config", {display: { position: "left"}});
        Beacon("init", AppSettings.HelpScoutBeaconId);
    }

    private setBeaconIdentify() {
        const user = this.authService.AppUser;
        if (user.AuthenticatedByIp) {
            Beacon("identify", { email: ""});
        } else if (user.Email && this.validEmail(user.Email)) {
            Beacon("identify", { email: user.Email });
        } else {
            Beacon("identify", { email: ""});
        }
    }

    private validEmail(email: string) {
        const regex = /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
        return regex.test(email);
    }
}



// WEBPACK FOOTER //
// ./~/tslint-loader??ref--0!./src/shared/helpers/helpscout.ts